/* eslint-disable prefer-const */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable id-blacklist */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable eqeqeq */
import { Component, Input, NgZone, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Stripe } from '@awesome-cordova-plugins/stripe/ngx';
import { UserApiService } from '../services/user-api.service';
import { GiftTypePage } from '../gift-type/gift-type.page';
import { SignupFriendPage } from '../signup-friend/signup-friend.page';
interface paymentData {
  cardnumber: String;
  expiryMonth: String;
  expiryYear: String;
  CVV: String;
}
@Component({
  selector: 'app-buy-giftcard',
  templateUrl: './buy-giftcard.page.html',
  styleUrls: ['./buy-giftcard.page.scss'],
})
export class BuyGiftcardPage implements OnInit {
  months: any[] = [
    { id: '01', name: 'January', shortName: 'Jan' },
    { id: '02', name: 'February', shortName: 'Feb' },
    { id: '03', name: 'March', shortName: 'Mar' },
    { id: '04', name: 'April', shortName: 'Apr' },
    { id: '05', name: 'May', shortName: 'May' },
    { id: '06', name: 'June', shortName: 'Jun' },
    { id: '07', name: 'July', shortName: 'Jul' },
    { id: '08', name: 'August', shortName: 'Aug' },
    { id: '09', name: 'September', shortName: 'Sep' },
    { id: '10', name: 'October', shortName: 'Oct' },
    { id: '11', name: 'November', shortName: 'Nov' },
    { id: '12', name: 'December', shortName: 'Dec' },
  ];

  years: any[] = [];

  paymentForm: FormGroup;
  // loginData
  segment = 'buy';
  payData: paymentData;
  isSubmitted: boolean = false;
  @Input('data') data;
  banner;
  paymentType = 'credit_card';
  amount;
  message = '';
  stripeId = '';
  buyUsingCard = true;
  udid: any;
  cardinfo: any = {
    number: '',
    expMonth: '',
    expYear: '',
    cvc: '',
  };
  shareUDID: any;
  fr_name: any;
  email: any;
  ccFee;
  total;
  showDetails = false;
  captchaPassed: boolean = false;
  private captchaResponse: string;
  constructor(
    private modalController: ModalController,
    private server: UserApiService,
    public globals: GlobalVariable,
    private formBilder: FormBuilder,
    private alertCtrl: AlertController,
    private zone: NgZone,

    private stripe: Stripe
  ) {
    this.payData = {} as paymentData;
    this.years = this.getYearArray();
  }

  getYearArray(): number[] {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 13; i++) {
      years.push(currentYear + i);
    }
    return years;
  }
  ngOnInit() {
    this.paymentForm = this.formBilder.group({
      cardnumber: [
        '',
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(16),
          Validators.pattern('[0-9]*'),
          Validators.required,
        ]),
      ],
      expiryMonth: ['', Validators.compose([Validators.required])],
      expiryYear: ['', Validators.compose([Validators.required])],
      CVV: ['', Validators.compose([Validators.required])],
    });
    console.log(this.data);
    this.banner = this.data.banner;
    this.udid = this.data.udid;
  }
  ionViewWillEnter() {
    this.askType();
  }
  close() {
    this.modalController.dismiss();
  }
  async askType() {
    let modal = await this.modalController.create({
      component: GiftTypePage,
      initialBreakpoint: 0.3,
      breakpoints: [0.3, 0, 4],
      backdropDismiss: false,
      handle: false,
      mode: 'ios',
      showBackdrop: true,
      swipeToClose: false,
      keyboardClose: true,
      cssClass: 'giftModal',
    });
    modal.onDidDismiss().then((data) => {
      console.log(data.data);
      if (data.data == 'me') {
        this.segment = 'buy';
      } else if (data.data == 'friend') {
        this.segment = 'share';
      }
      //  else{
      //   this.close()
      //  }
    });
    modal.present();
  }
  clear() {
    console.log('kk');
    // this.globals.Loader();
    this.fr_name = undefined;
    this.email = undefined;
    this.shareUDID = undefined;
    // this.globals.loading.dismiss();
    this.sharePromt();
  }
  validateEmail(email) {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  segmentChanged(e) {
    this.email = undefined;
    this.fr_name = undefined;
    this.shareUDID = undefined;
    this.segment = e.detail.value;
    if (this.segment == 'share') {
      this.sharePromt();
    }
  }
  paymentUsing(e) {
    console.log(e.detail.value);
    this.paymentType = e.detail.value;
    if (this.paymentType == 'credit_card') {
      this.buyUsingCard = true;
    } else {
      this.buyUsingCard = false;
    }
  }
  async createUser(email) {
    const prompt = await this.alertCtrl.create({
      header: 'No User Found',
      message: 'Do you want to create this user ' + email,
      mode: 'ios',
      backdropDismiss: false,

      buttons: [
        {
          text: 'Cancel',
          handler: (data) => {
            this.segment = 'buy';
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Create',
          handler: (data) => {
            this.signupUser(email);
          },
        },
      ],
    });
    prompt.present();
  }
  async signupUser(email) {
    let modal = await this.modalController.create({
      component: SignupFriendPage,
      componentProps: { email },
      cssClass: 'signUpModal',
      breakpoints: [0.5, 0.7, 1],
      initialBreakpoint: 0.7,
      backdropDismiss: false,
      mode: 'ios',
      swipeToClose: false,
      handle: false,
    });
    modal.present();
    modal.onDidDismiss().then((res) => {
      console.log(res.data);
      if (res.data) {
        let user = res.data;
        this.fr_name = user.first_name + ' ' + user.last_name;
        this.email = user.email;
        this.shareUDID = user.udid;
      } else {
        this.globals.presentToast(
          'failed to register User !, Switching to buy for yourself',
          'middle'
        );
        this.segment = 'buy';
      }
    });
  }
  async sharePromt() {
    // this.globals.loading.dismiss()
    const prompt = await this.alertCtrl.create({
      header: 'Share',
      message: 'Enter email of your friend',
      mode: 'ios',
      backdropDismiss: false,
      inputs: [
        {
          name: 'email',
          type: 'text',
          placeholder: 'friend@email.com',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: (data) => {
            this.segment = 'buy';
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Send',
          handler: (data) => {
            this.search_user(data.email);
          },
        },
      ],
    });
    prompt.present();
  }
  search_user(email) {
    if (!this.validateEmail(email)) {
      this.globals.presentToast('Invalid Email Format.', 'middle');
      this.sharePromt();
    } else {
      console.log('VALID EMAIL', email);
      this.globals.Loader();

      let response = this.server.search_user(email);
      response.subscribe(
        (data) => {
          console.log(data);
          this.globals.loading.dismiss();
          if (data.length == 0) {
            // this.globals.presentToast("No User Found",'middle');
            this.createUser(email);
            // this.showConfirm_new_user(email,id)
          } else {
            this.fr_name = data[0].name;
            this.shareUDID = data[0].udid;
            this.email = data[0].email;
            // this.navCtrl.push('BuygiftcardsPage',{gift_id:id,udid_r:data[0].udid,design_id:this.design_id,amount:this.amount,message:this.message});
          }
          this.globals.loading.dismiss();
        },
        (error) => {
          // loading.dismiss();
          this.globals.loading.dismiss();

          this.globals.presentToast(
            'Failure',
            'Something went wrong check your internet connection.'
          );
        }
      );
    }
  }
  // buyNow(){
  // if(this.amount==0 ||this.amount==undefined){
  //   this.globals.presentToast('Amount is $0');
  //   return
  // }
  // this.server.buyGiftCardByCash(this.banner.design_id,this.banner.design_id,this.amount,this.message)
  // .subscribe(res=>{
  //   console.log(res)
  //   if(res.status==true){
  //     this.globals.presentToast(res.message)
  //     this.close();
  //     //pending
  //   }
  // },err=>{
  //   this.globals.presentToast('Failed, network error')
  // })

  // }
  checkout() {
    console.log('hellllo1');

    if (this.amount == 0 || this.amount == undefined) {
      this.globals.presentToast('Amount is $0');
      this.isSubmitted = true;
      console.log('hellllo2');

      return;
    }
    if (this.segment == 'buy') {
      this.shareUDID = '';
      console.log('hellllo3');
    }

    if (!this.paymentForm.valid) {
      this.isSubmitted = true;
      console.log('hellllo4');

      document.getElementById('carddetail').scrollIntoView();

      console.log('Please provide all the required values!');
      return false;
    } else {
      console.log('hellllo5');

      this.ccFeeCalculate();
      this.showDetails = true;
    }
  }
  buyUsingCreditCard(CardData) {
    console.log(CardData);
    this.isSubmitted = true;
    if (this.amount == 0 || this.amount == undefined) {
      this.globals.presentToast('Amount is $0');
      this.isSubmitted = true;
      return;
    }
    console.log(this.total);
    console.log('share',this.shareUDID);

    if (this.segment == 'buy') {
      this.shareUDID = '';
    }

    // if (this.globals.StripId == '' || this.globals.StripId == null) {
    //   this.globals.presentToast('Payments not available/ payment id not found');
    // } else {
      this.globals.loader();
      this.ccFeeCalculate();
      
      this.cardinfo = {
        number: CardData.cardnumber,
        expMonth: CardData.expiryMonth,
        expYear: CardData.expiryYear,
        cvc: CardData.CVV,
      };


      this.captchaPassed = true;
      
      this.server.buyGiftCardByCreditCard(
          this.captchaResponse,
         '',
          this.banner.design_id,
          this.banner.design_id,
          this.total,
          this.message,
          this.shareUDID,
          this.ccFee,
          this.cardinfo
        )
        .subscribe(
          (res) => {
            if (!res.status) {
              this.captchaPassed = false;
              this.globals.dismiss();
              this.globals.presentToast(res.message,'middle',3500);
            }else{
              this.captchaPassed = false;
              this.globals.dismiss();
              this.globals.presentToast(res.message);
              this.close();
            }
          
          },
          (err) => {
            this.captchaPassed = false;
            this.globals.dismiss();

            this.globals.presentToast('Something went wrong,try again');
          }
        );
      // this.stripe
      //   .createCardToken(this.cardinfo)
      //   .then(
      //     (token) => {
           
      //     },
      //     (err) => {
      //       console.log('Error', err);
      //       this.globals.dismiss();

      //       this.globals.presentToast(
      //         'Error! Please verify that you\'ve entered correct card information.',
      //         'middle'
      //       );
      //     }
      //   )
      //   .catch((error) => {
      //     this.globals.presentToast('Something went wrong, try again');
      //   });
    // }
  }
  
  get errorControl() {
    return this.paymentForm.controls;
  }
  ccFeeCalculate() {
    if (this.globals.cash_discount_enabled && this.globals.card_enabled) {
      console.log('hellllo8', this.total);

      this.ccFee = (
        (Number(this.globals.cash_discount_percentage) / 100) *
        Number(this.amount)
      ).toFixed(2);
      this.ccFee =
        Number(this.ccFee) + Number(this.globals.cash_discount_value);
      this.ccFee = this.ccFee.toFixed(2);
      this.total = this.amount + Number(this.ccFee);
      console.log('total with ccFee ', this.ccFee);
    } else {
      this.total = this.amount;
    }
  }

  captchaResolved(response: string): void {
    this.zone.run(() => {
      this.captchaResponse = response;
    });
  }
}
